import React from 'react';
import { TimelineListItemTitleText } from '../shared/TimelineListItemTitleText';
import { TimelineListItemDateText } from '../shared/TimelineListItemDateText';
import dayjs from 'dayjs';
import { TimelineListItemInfoChip } from '../shared/TimelineListItemInfoChip';
import '@fontsource/lato';
export const AdminTimelineListItem = (props) => {
    const { timelineActivity } = props;
    return (React.createElement("div", { className: 'rounded bg-white pl-4 pt-4 pr-4 pb-4 space-y-2 block justify-start m-4' },
        React.createElement(TimelineListItemTitleText, { titleText: timelineActivity.activityTitle }),
        React.createElement(TimelineListItemDateText, { nameText: timelineActivity.userName, dateText: dayjs(timelineActivity.date).format('MM/DD/YYYY HH:mm A') }),
        React.createElement("div", null,
            React.createElement(TimelineListItemInfoChip, { label: '', value: timelineActivity.newState ?? '', backgroundColor: '#F5F5F5', textColor: '#757575', showPhoneIcon: false, crossOut: false }))));
};
